import React from 'react';
import { Header } from '../components/Header';
import { Navigation } from '../components/Navigation';
import { MarketTicker } from '../components/MarketTicker';
import { MarketStrip } from '../components/MarketStrip';
import { HeroSection } from '../components/HeroSection';
import { BottomArticles } from '../components/BottomArticles';
import { AdPlaceholder } from '../components/AdPlaceholder';
export function Home() {
  return <div className="min-h-screen bg-white font-sans text-gray-900" data-id="element-476">
      <div className="max-w-[1200px] mx-auto px-4 sm:px-6 lg:px-8" data-id="element-477">
        <Header data-id="element-478" />
        <Navigation data-id="element-479" />
      </div>

      {/* Full-width ticker bar */}
      <MarketTicker data-id="element-480" />

      <div className="max-w-[1200px] mx-auto px-4 sm:px-6 lg:px-8" data-id="element-481">
        {/* Top Banner Ad */}
        <div className="py-6 flex justify-center" data-id="element-482">
          <AdPlaceholder width="w-full max-w-[728px]" height="h-[90px]" text="Wenda Ingredients Advertisement" data-id="element-483" />
        </div>

        <main data-id="element-484">
          <HeroSection data-id="element-485" />
          <MarketStrip autoScroll data-id="element-486" />
          <BottomArticles data-id="element-487" />
        </main>

        {/* Bottom Banner Ad */}
        <div className="py-8 border-t border-gray-200 flex justify-center" data-id="element-488">
          <AdPlaceholder width="w-full max-w-[970px]" height="h-[90px]" text="Intralox Advertisement" data-id="element-489" />
        </div>
      </div>
    </div>;
}